// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  position: fixed;
  width: 100%;
  display: block;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  padding-bottom: 12px;
}

@media screen and (min-width: 1281px) {
  .menu {
    padding-left: 20%;
    padding-right: 20%;
  }
}
.toolbar {
  padding-top: 10px;
  height: 77px;
  overflow: visible;
  flex-wrap: wrap;
  transition: all 0.3s linear;
}

.toolbar.scrolled {
  box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.1);
  background-color: #f8f8f8 !important;
}

.toolbar-content {
  display: flex;
  margin: 0px auto;
  max-width: 1280px;
  width: 100%;
}

.company-logo {
  width: 120px;
}

.item {
  text-transform: uppercase;
  font-family: "Work Sans", sans-serif;
  font-size: 14px;
  color: #383838;
  font-weight: 500;
}

.menu-button {
  display: inline-block;
}

.toolbar-spacer {
  flex: 999 999 200px;
}

.toolbar-links {
  display: none;
  flex-grow: 1;
  justify-content: space-around;
}

.bg-white {
  background-color: white;
}

button {
  cursor: pointer;
  border: 0px solid black;
  background-color: transparent;
  flex: 1 1 auto;
}

@media only screen and (min-width: 769px) {
  .menu-button {
    display: none;
  }
  .toolbar-spacer {
    flex-grow: 1;
  }
  .toolbar-links {
    display: flex;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/menu/menu.component.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;EACA,WAAA;EACA,cAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,aAAA;EACA,oBAAA;AACJ;;AAQA;EACI;IACI,iBAAA;IACA,kBAAA;EALN;AACF;AAQA;EACI,iBAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;EACA,2BAAA;AANJ;;AASA;EACI,8CAAA;EACA,oCAAA;AANJ;;AAUA;EACI,aAAA;EACA,gBAAA;EACA,iBAAA;EACA,WAAA;AAPJ;;AAUA;EACI,YAAA;AAPJ;;AAUA;EACI,yBAAA;EACA,oCAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;AAPJ;;AAUA;EACI,qBAAA;AAPJ;;AAUA;EACI,mBAAA;AAPJ;;AAUA;EACI,aAAA;EACA,YAAA;EACA,6BAAA;AAPJ;;AAUA;EACI,uBAAA;AAPJ;;AAUA;EACI,eAAA;EACA,uBAAA;EACA,6BAAA;EACA,cAAA;AAPJ;;AAWA;EACI;IACI,aAAA;EARN;EAWE;IACI,YAAA;EATN;EAYE;IACI,aAAA;EAVN;AACF","sourcesContent":[":host {\n    position: fixed;\n    width: 100%;\n    display: block;\n    top: 0;\n    left: 0;\n    right: 0;\n    z-index: 1000;\n    padding-bottom: 12px;\n}\n\nmat-toolbar {\n}\n\nmat-toolbar.scrolled {\n}\n\n@media screen and (min-width: 1281px) {\n    .menu {\n        padding-left: 20%;\n        padding-right: 20%;\n    }\n}\n\n.toolbar {\n    padding-top: 10px;\n    height: 77px;\n    overflow: visible;\n    flex-wrap: wrap;\n    transition: all 0.3s linear;\n}\n\n.toolbar.scrolled {\n    box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.1);\n    background-color: #f8f8f8 !important; \n}\n\n\n.toolbar-content {\n    display: flex;\n    margin: 0px auto;\n    max-width: 1280px;\n    width: 100%;\n}\n\n.company-logo {\n    width: 120px;\n}\n\n.item {\n    text-transform: uppercase;\n    font-family: 'Work Sans', sans-serif;\n    font-size: 14px;\n    color: darken(#9e9e9e, 40%);\n    font-weight: 500;\n}\n\n.menu-button {\n    display: inline-block;\n}\n\n.toolbar-spacer {\n    flex: 999 999 200px;\n}\n\n.toolbar-links {\n    display: none;\n    flex-grow: 1;\n    justify-content: space-around;\n}\n\n.bg-white {\n    background-color:white;\n}\n\nbutton {\n    cursor:pointer;\n    border: 0px solid black;\n    background-color: transparent;\n    flex: 1 1 auto;\n\n}\n\n@media only screen and (min-width: 769px) {\n    .menu-button {\n        display: none;\n    }\n\n    .toolbar-spacer {\n        flex-grow: 1;\n    }\n\n    .toolbar-links {\n        display: flex;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
